export default __webpack_public_path__ + "static/media/TM.a26261fa.svg";